export const developerLinks = [
  { name: "Documentation", id: 3001 },
  { name: "Authentication", id: 3002 },
  { name: "API Reference", id: 3003 },
  { name: "Support", id: 3004 },
  { name: "Open Source", id: 3005 },
];
export const resourceLinks = [
  { name: "Authentication", id: 3006 },
  { name: "System Status", id: 3007 },
  { name: "Terms of Service", id: 3008 },
  { name: "Pricing", id: 3009 },
  { name: "Over Right", id: 3010 },
];
